export default __webpack_public_path__ + "static/cabin-deluxe-2-to-3-1-e5947dd96e1677c5186501b4abbaf0aa.jpg";